import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../components/context/AuthProvider';

export default function PrivateRoute({ children }) {
  const { user, authLoading } = useAuth();

  if (authLoading) {
    return <div className="p-10 text-center">Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
}
